import AllData from "./components/pages/AllData/AllData";
import GraphingTool from "./components/pages/GraphingTool/GraphingTool";
import CreditRatingView from "./components/pages/CreditRatingView/CreditRatingView";
import FTPOrSpreadData from "./components/pages/FTPOrSpreadData/FTPOrSpreadData";
import HRKRIReportingAnalytics from "./components/pages/HRKRIReportingAnalytics/HRKRIReportingAnalytics";
import HRModelerAnalytics from "./components/pages/HRModelerAnalytics/HRModelerAnalytics";
import HRModelerAnalyticsGlobal from "./components/pages/HRModelerAnalyticsGlobal/HRModelerAnalyticsGlobal";
import TreasuryKRISummary from "./components/pages/TreasuryKRISummary/TreasuryKRISummary";
import LiquidityPlan from "./components/pages/LiquidityPlan/LiquidityPlan";
import LiquidityPlanGlobal from "./components/pages/LiquidityPlanGlobal/LiquidityPlanGlobal";
import CounterpartyRisk from "./components/pages/CounterpartyRisk/CounterpartyRisk";
import TreasuryMTBPTemplate from "./components/pages/TreasuryMTBPTemplate/TreasuryMTBPTemplate";
import FinanceReport from "./components/pages/FinanceReport/FinanceReport";
import DAF2Treasury from "./components/pages/DAF2Treasury/DAF2Treasury";
import DAF2TreasuryModeler from "./components/pages/DAF2TreasuryModeler/DAF2TreasuryModeler";
import DAF2TreasuryModelerGlobal from "./components/pages/DAF2TreasuryModelerGlobal/DAF2TreasuryModelerGlobal";
import { BloombergProvider } from "./context/BloombergContext";
import { CreditRatingProvider } from "./context/CreditRatingContext";
import { GraphingToolProvider } from "./context/GraphingToolContext";
import { FileUploadProvider } from "./context/FileUploadContext";
import { DataUploadProvider } from "./context/DataUploadContext";
import { DocumentUploadProvider } from "./context/DocumentUploadContext";
import AdminManagement from "./components/pages/AdminManagement/AdminManagement";
import { AdminManagementProvider } from "./context/AdminManagementContext";
import Profile from "./components/pages/Profile/Profile";
import Other from "./components/pages/Other/Other";
import SensitivityGAP from "./components/pages/SensitivityGAP/SensitivityGAP";
import SensitivityGAPGlobal from "./components/pages/SensitivityGAPGlobal/SensitivityGAPGlobal";
import LiquidityGAP from "./components/pages/LiquidityGAP/LiquidityGAP";
import LiquidityGAPGlobal from "./components/pages/LiquidityGAPGlobal/LiquidityGAPGlobal";
import NIISensitivity from "./components/pages/NIISensitivity/NIISensitivity";
import NIISensitivityModeler from "./components/pages/NIISensitivityModeler/NIISensitivityModeler";
import NIISensitivityModelerGlobal from "./components/pages/NIISensitivityModelerGlobal/NIISensitivityModelerGlobal";
import EVESensitivityModeler from "./components/pages/EVESensitivityModeler/EVESensitivityModeler";
import EVESensitivityModelerGlobal from "./components/pages/EVESensitivityModelerGlobal/EVESensitivityModelerGlobal";
import EVESensitivity from "./components/pages/EVESensitivity/EVESensitivity";
import BalSheetLiqRatio from "./components/pages/BalSheetLiqRatio/BalSheetLiqRatio";
import BalSheetLiqRatioModeler from "./components/pages/BalSheetLiqRatioModeler/BalSheetLiqRatioModeler";
import BalSheetLiqRatioModelerGlobal from "./components/pages/BalSheetLiqRatioModelerGlobal/BalSheetLiqRatioModelerGlobal";
import STDTD from "./components/pages/STDTD/STDTD";
import LTDC from "./components/pages/LTDC/LTDC";
import STDTDModeler from "./components/pages/STDTDModeler/STDTDModeler";
import STDTDModelerGlobal from "./components/pages/STDTDModelerGlobal/STDTDModelerGlobal";
import FileUpload from "./components/pages/FileUpload/FileUpload";
import DocumentUpload from "./components/pages/DocumentUpload/DocumentUpload";
import DataUpload from "./components/pages/DataUpload/DataUpload";
import LTDCModeler from "./components/pages/LTDCModeler/LTDCModeler";
import LTDCModelerGlobal from "./components/pages/LTDCModelerGlobal/LTDCModelerGlobal";
import Dashboard from "./components/pages/Dashboard/Dashboard";
import ControlGLReconciliation from "./components/pages/ControlGLReconciliation/ControlGLReconciliation";
import ControlGLReconciliationModeler from "./components/pages/ControlGLReconciliationModeler/ControlGLReconciliationModeler";
import ControlGLReconciliationModelerGlobal from "./components/pages/ControlGLReconciliationModelerGlobal/ControlGLReconciliationModelerGlobal";
import BalanceSheet from "./components/pages/BalanceSheet/BalanceSheet";
import TreasuryKRIEssbaseSummary from "./components/pages/TreasuryKRIEssbaseSummary/TreasuryKRIEssbaseSummary";
import KRISummarySubmissionModeler from "./components/pages/KRISummarySubmissionModeler/KRISummarySubmissionModeler";
import KRISummarySubmissionGlobal from "./components/pages/KRISummarySubmissionGlobal/KRISummarySubmissionGlobal";
import { EmpyreanProvider } from "./context/EmpyreanContext";
import EmpyreanOPDB from "./components/pages/EmpyreanOPDB/EmpyreanOPDB.component";

/* 
title : To show the title in the menu
path: To route to the page
pageId: Array of ids to check the access,
component: To render the page component
subPages: To show the sub pages in the menu
 */

export const WA_ADMIN_MANAGEMENT = "WA_ADMIN_MANAGEMENT";

export const pages = [
  {
    title: "Dashboard",
    path: "dashboard",
    pageId: ["WA_DASHBOARD"],
    component: () => <Dashboard />,
  },
  {
    title: "Market Data",
    path: "marketData",
    pageId: ["WA_MARKET_DATA_PARENT"],
    subPages: [
      {
        title: "All Data",
        path: "marketData/allData",
        pageId: ["WA_MAR_ALL_DATA"],
        component: () => (
          <BloombergProvider>
            <AllData />
          </BloombergProvider>
        ),
      },
      {
        title: "Interest Rate Graphing Tool",
        path: "marketData/graphingTool",
        pageId: ["WA_MAR_INTEREST_RATE_GRAPHING_TOOL"],
        component: () => (
          <GraphingToolProvider>
            <GraphingTool />
          </GraphingToolProvider>
        ),
      },
      {
        title: "Credit Rating View",
        path: "marketData/creditRatingView",
        pageId: ["WA_MAR_CREDIT_RATING_VIEW"],
        component: () => (
          <CreditRatingProvider>
            <CreditRatingView />
          </CreditRatingProvider>
        ),
      },
      {
        title: "FTP Spread Data",
        path: "marketData/ftpOrSpreadData",
        pageId: ["WA_MAR_FTP_SPREAD_DATA_PAGE"],
        component: () => <FTPOrSpreadData page="FTP / Spread Data" />,
      },
    ],
  },
  {
    title: "Treasury Report",
    path: "treasuryReport",
    pageId: ["WA_TREASURY_REPORT_PARENT"],
    subPages: [
      {
        title: "Treasury KRI Summary",
        path: "treasuryReport/treasuryKriSummary",
        pageId: ["WA_TR_TEASURY_KRI_SUMMARY"],
        subPages: [
          {
            title: "Balance Sheet Summary",
            path: "treasuryReport/treasuryKriSummary/balanceSheetSummary",
            pageId: ["WA_TR_BALANCE_SHEET_SUMMARY"],
            component: () => (
              <Other page="Balance Sheet Summary of Treasury Report" />
            ),
          },
          {
            title: "Global KRI Summary",
            path: "treasuryReport/treasuryKriSummary/kriSummarySubmissionGlobal",
            pageId: ["WA_TR_KRI_SUMMARY_SUBMISSION_GLOBAL"],
            component: () => <KRISummarySubmissionGlobal />,
          },
          {
            title: "SFC KRI History",
            path: "treasuryReport/treasuryKriSummary/kriSummary",
            pageId: ["WA_TR_KRI_SUMMARY"],
            component: TreasuryKRISummary,
          },
          {
            title: "KRI Essbase Summary",
            path: "treasuryReport/treasuryKriSummary/kriEssbaseSummary",
            pageId: ["WA_TR_KRI_ESSBASE_SUMMARY"],
            component: TreasuryKRIEssbaseSummary,
          },
          {
            title: "Metrics Data table",
            path: "treasuryReport/treasuryKriSummary/metricsDataTable",
            pageId: ["WA_TR_METRICS_DATA_TABLE"],
            component: () => (
              <Other page="Metrics Data table of Treasury Report" />
            ),
          },
          {
            title: "Treasury KRI Limits & Approval",
            path: "treasuryReport/treasuryKriSummary/treasuryKriLimitsAndApproval",
            pageId: ["WA_TR_TREASURY_KRI_LIMITS_AND_APPROVAL"],
            component: () => (
              <Other page="Treasury KRI Limits & Approval of Treasury Report" />
            ),
          },
          {
            title: "Line Charts / Bar charts",
            path: "treasuryReport/treasuryKriSummary/lineChartsOrBarCharts",
            pageId: ["WA_TR_LINE_CHARTS_OR_BAR_CHARTS"],
            component: () => (
              <Other page="Line Charts / Bar charts of Treasury Report" />
            ),
          },
        ],
      },
      {
        title: "Interest Rate Risk",
        path: "treasuryReport/interestRateRisk",
        pageId: ["WA_TR_INTEREST_RATE_RISK"],
        subPages: [
          {
            title: "HR Analytics",
            path: "treasuryReport/interestRateRisk/hrKriAnalytics",
            pageId: ["WA_TR_HEDGE_RATIO_KRI_ANALYTICS"],
            component: () => <HRKRIReportingAnalytics toCompare={false} />,
          },
          {
            title: "HR Analytics Compare",
            path: "treasuryReport/interestRateRisk/hrKriAnalyticsCompare",
            pageId: ["WA_TR_HEDGE_RATIO_KRI_ANALYTICS_COMPARE"],
            component: () => <HRKRIReportingAnalytics toCompare={true} />,
          },
          {
            title: "NII Sensitivity",
            path: "treasuryReport/interestRateRisk/niiSensitivity",
            pageId: ["WA_TR_NII_SENSITIVITY"],
            component: () => <NIISensitivity toCompare={false} />,
          },
          {
            title: "NII Sensitivity Compare",
            path: "treasuryReport/interestRateRisk/niiSensitivityCompare",
            pageId: ["WA_TR_NII_SENSITIVITY_COMPARE"],
            component: () => <NIISensitivity toCompare={true} />,
          },
          {
            title: "EVE Sensitivity",
            path: "treasuryReport/interestRateRisk/eveSensitivity",
            pageId: ["WA_TR_EVE_SENSITIVITY"],
            component: () => <EVESensitivity toCompare={false} />,
          },
          {
            title: "EVE Sensitivity Compare",
            path: "treasuryReport/interestRateRisk/eveSensitivityCompare",
            pageId: ["WA_TR_EVE_SENSITIVITY_COMPARE"],
            component: () => <EVESensitivity toCompare={true} />,
          },
        ],
      },
      {
        title: "Liquidity Risk",
        path: "treasuryReport/liquidityRisk",
        pageId: ["WA_TR_LIQUIDITY_RISK"],
        subPages: [
          /* {
            title: "TMCC Daily Cash Coverage model",
            path: "treasuryReport/liquidityRisk/tmccDailyCashCoverageModel",
            pageId: ["WA_TR_TMCC_DAILY_CASH_COVERAGE_MODEL"],
            component: () => (
              <Other page="TMCC Daily Cash Coverage model of Treasury Report" />
            ),
          }, */
          {
            title: "DAF2 Template",
            path: "treasuryReport/liquidityRisk/daf2Template",
            pageId: ["WA_TR_DAF2_TEMPLATE"],
            component: () => <DAF2Treasury />,
          },
          {
            title: "Balance Sheet Liquidity Ratio",
            path: "treasuryReport/liquidityRisk/balanceSheetLiquidityRatio",
            pageId: ["WA_TR_BALANCE_SHEET_LIQUIDITY_RATIO"],
            component: () => <BalSheetLiqRatio />,
          },
          {
            title: "Short Term Debt",
            path: "treasuryReport/liquidityRisk/shortTermDebt",
            pageId: ["WA_TR_SHORT_TERM_DEBT"],
            component: () => <STDTD />,
          },
          {
            title: "Long Term Debt Concentration",
            path: "treasuryReport/liquidityRisk/longTermDebtConcentration",
            pageId: ["WA_TR_LONG_TERM_DEBT_CONCENTRATION"],
            component: () => <LTDC />,
          },
        ],
      },
      {
        title: "Liquidity Plan",
        path: "treasuryReport/liquidityPlan",
        pageId: ["WA_TR_LIQUIDITY_PLAN"],
        component: () => (
          <LiquidityPlan page="Liquidity Plan of Treasury Report" />
        ),
      },
      {
        title: "Control - GL Reconciliation",
        path: "treasuryReport/controlGLReconciliation",
        pageId: ["WA_TR_CONTROL_GL_RECONCILIATION"],
        component: () => <ControlGLReconciliation />,
      },
      {
        title: "Counterparty Risk",
        path: "treasuryReport/counterpartyRisk",
        pageId: ["WA_TR_COUNTERPARTY_RISK"],
        component: () => <CounterpartyRisk page="Counterparty Risk" />,
      },
      {
        title: "Emerging Market Cross Border Risk",
        path: "treasuryReport/emergingMarketCrossBorderRisk",
        pageId: ["WA_TR_EMERGING_MARKET_CROSS_BORDER_RISK"],
        component: () => <Other page="Emerging Market Cross Border Risk" />,
      },
      {
        title: "TFS Group Financing",
        path: "treasuryReport/tfsGroupFinancing",
        pageId: ["WA_TR_TFS_GROUP_FINANCING"],
        component: () => <Other page="TFS Group Financing" />,
      },
    ],
  },
  {
    title: "Treasury Modeler Analytics",
    path: "treasuryModelerAnalytics",
    pageId: ["WA_TREASURY_MODELER_ANALYTICS_PARENT"],
    subPages: [
      {
        title: "Interest Rate Risk (Modeler)",
        path: "treasuryModelerAnalytics/interestRateRisk",
        pageId: ["WA_TMOD_INTEREST_RATE_RISK"],
        subPages: [
          {
            title: "HR Modeler Analytics",
            path: "treasuryModelerAnalytics/interestRateRisk/hrModelerAnalytics",
            pageId: ["WA_TMOD_HEDGE_RATIO_MODELER_ANALYTICS"],
            component: () => <HRModelerAnalytics toCompare={false} />,
          },
          {
            title: "HR Modeler Analytics Compare",
            path: "treasuryModelerAnalytics/interestRateRisk/hrModelerAnalyticsCompare",
            pageId: ["WA_TMOD_HEDGE_RATIO_MODELER_ANALYTICS_COMPARE"],
            component: () => <HRModelerAnalytics toCompare={true} />,
          },
          {
            title: "NII Sensitivity (Modeler)",
            path: "treasuryModelerAnalytics/interestRateRisk/niiSensitivity",
            pageId: ["WA_TMOD_NII_SENSITIVITY"],
            component: () => <NIISensitivityModeler toCompare={false} />,
          },
          {
            title: "NII Sensitivity Compare (Modeler)",
            path: "treasuryModelerAnalytics/interestRateRisk/niiSensitivityCompare",
            pageId: ["WA_TMOD_NII_SENSITIVITY_COMPARE"],
            component: () => <NIISensitivityModeler toCompare={true} />,
          },
          {
            title: "EVE Sensitivity (Modeler)",
            path: "treasuryModelerAnalytics/interestRateRisk/eveSensitivity",
            pageId: ["WA_TMOD_EVE_SENSITIVITY"],
            component: () => <EVESensitivityModeler toCompare={false} />,
          },
          {
            title: "EVE Sensitivity Compare (Modeler)",
            path: "treasuryModelerAnalytics/interestRateRisk/eveSensitivityCompare",
            pageId: ["WA_TMOD_EVE_SENSITIVITY_COMPARE"],
            component: () => <EVESensitivityModeler toCompare={true} />,
          },
        ],
      },
      {
        title: "Liquidity Risk (Modeler)",
        path: "treasuryModelerAnalytics/liquidityRisk",
        pageId: ["WA_TMOD_LIQUIDITY_RISK"],
        subPages: [
          /* {
            title: "TMCC Daily Cash Coverage model (Modeler)",
            path: "treasuryModelerAnalytics/liquidityRisk/tmccDailyCashCoverageModel",
            pageId: ["WA_TMOD_TMCC_DAILY_CASH_COVERAGE_MODEL"],
            component: () => (
              <Other page="TMCC Daily Cash Coverage model of Treasury Modeler Analytics" />
            ),
          }, */
          {
            title: "DAF2 Template (Modeler)",
            path: "treasuryModelerAnalytics/liquidityRisk/daf2Template",
            pageId: ["WA_TMOD_DAF2_TEMPLATE"],
            component: () => <DAF2TreasuryModeler />,
          },
          {
            title: "Balance Sheet Liquidity Ratio (Modeler)",
            path: "treasuryModelerAnalytics/liquidityRisk/balanceSheetLiquidityRatio",
            pageId: ["WA_TMOD_BALANCE_SHEET_LIQUIDITY_RATIO"],
            component: () => <BalSheetLiqRatioModeler />,
          },
          {
            title: "Short Term Debt (Modeler)",
            path: "treasuryModelerAnalytics/liquidityRisk/shortTermDebt",
            pageId: ["WA_TMOD_SHORT_TERM_DEBT"],
            component: () => <STDTDModeler />,
          },
          {
            title: "Long Term Debt Concentration (Modeler)",
            path: "treasuryModelerAnalytics/liquidityRisk/longTermDebtConcentration",
            pageId: ["WA_TMOD_LONG_TERM_DEBT_CONCENTRATION"],
            component: () => <LTDCModeler />,
          },
        ],
      },
      {
        title: "Liquidity Plan (Modeler)",
        path: "treasuryModelerAnalytics/liquidityPlan",
        pageId: ["WA_TMOD_LIQUIDITY_PLAN"],
        component: () => (
          <LiquidityPlan page="Liquidity Plan of Treasury Modeler Analytics" />
        ),
      },
      {
        title: "Control - GL Reconciliation (Modeler)",
        path: "treasuryModelerAnalytics/controlGLReconciliation",
        pageId: ["WA_TMOD_CONTROL_GL_RECONCILIATION"],
        component: () => <ControlGLReconciliationModeler />,
      },
      {
        title: "Balance Sheet (Modeler)",
        path: "treasuryModelerAnalytics/balanceSheet",
        pageId: ["WA_TMOD_BALANCE_SHEET"],
        component: () => <BalanceSheet />,
      },
      {
        title: "KRI Summary Submission (Modeler)",
        path: "treasuryModelerAnalytics/kriSummarySubmission",
        pageId: ["WA_TMOD_KRI_SUMMARY_SUBMISSION"],
        component: () => <KRISummarySubmissionModeler />,
      },
      {
        title: "Additional Schedules (Modeler)",
        path: "treasuryModelerAnalytics/additionalSchedules",
        pageId: ["WA_TMOD_ADDITIONAL_SCHEDULES"],
        subPages: [
          {
            title: "Sensitivity GAP (Modeler)",
            path: "treasuryModelerAnalytics/additionalSchedules/sensitivityGap",
            pageId: ["WA_TMOD_SENSITIVITY_GAP"],
            component: () => <SensitivityGAP />,
          },
          {
            title: "Liquidity GAP (Modeler)",
            path: "treasuryModelerAnalytics/additionalSchedules/liquidityGap",
            pageId: ["WA_TMOD_LIQUIDITY_GAP"],
            component: () => <LiquidityGAP />,
          },
          {
            title: "Balance Sheet Run Off (Modeler)",
            path: "treasuryModelerAnalytics/additionalSchedules/balanceSheetRunOff",
            pageId: ["WA_TMOD_BALANCE_SHEET_RUN_OFF"],
            component: () => <Other page="Balance Sheet Run Off Page" />,
          },
        ],
      },
    ],
  },
  {
    title: "Treasury Modeler Analytics (Global View)",
    path: "treasuryModelerAnalyticsGlobal",
    pageId: ["WA_TREASURY_MODELER_ANALYTICS_PARENT_GLOBAL"],
    subPages: [
      {
        title: "Interest Rate Risk (Modeler) Global",
        path: "treasuryModelerAnalyticsGlobal/interestRateRiskGlobal",
        pageId: ["WA_TMOD_INTEREST_RATE_RISK_GLOBAL"],
        subPages: [
          {
            title: "HR Modeler Analytics Global",
            path: "treasuryModelerAnalyticsGlobal/interestRateRiskGlobal/hrModelerAnalyticsGlobal",
            pageId: ["WA_TMOD_HEDGE_RATIO_MODELER_ANALYTICS_GLOBAL"],
            component: () => <HRModelerAnalyticsGlobal toCompare={false} />,
          },
          {
            title: "HR Modeler Analytics Compare Global",
            path: "treasuryModelerAnalyticsGlobal/interestRateRiskGlobal/hrModelerAnalyticsCompareGlobal",
            pageId: ["WA_TMOD_HEDGE_RATIO_MODELER_ANALYTICS_COMPARE_GLOBAL"],
            component: () => <HRModelerAnalyticsGlobal toCompare={true} />,
          },
          {
            title: "NII Sensitivity (Modeler) Global",
            path: "treasuryModelerAnalyticsGlobal/interestRateRiskGlobal/niiSensitivityGlobal",
            pageId: ["WA_TMOD_NII_SENSITIVITY_GLOBAL"],
            component: () => <NIISensitivityModelerGlobal toCompare={false} />,
          },
          {
            title: "NII Sensitivity (Modeler) Compare Global",
            path: "treasuryModelerAnalyticsGlobal/interestRateRiskGlobal/niiSensitivityCompareGlobal",
            pageId: ["WA_TMOD_NII_SENSITIVITY_COMPARE_GLOBAL"],
            component: () => <NIISensitivityModelerGlobal toCompare={true} />,
          },
          {
            title: "EVE Sensitivity (Modeler) Global",
            path: "treasuryModelerAnalyticsGlobal/interestRateRiskGlobal/eveSensitivityGlobal",
            pageId: ["WA_TMOD_EVE_SENSITIVITY_GLOBAL"],
            component: () => <EVESensitivityModelerGlobal toCompare={false} />,
          },
          {
            title: "EVE Sensitivity (Modeler) Compare Global",
            path: "treasuryModelerAnalyticsGlobal/interestRateRiskGlobal/eveSensitivityCompareGlobal",
            pageId: ["WA_TMOD_EVE_SENSITIVITY_COMPARE_GLOBAL"],
            component: () => <EVESensitivityModelerGlobal toCompare={true} />,
          },
        ],
      },
      {
        title: "Liquidity Risk (Modeler) Global",
        path: "treasuryModelerAnalyticsGlobal/liquidityRiskGlobal",
        pageId: ["WA_TMOD_LIQUIDITY_RISK_GLOBAL"],
        subPages: [
          /* {
            title: "TMCC Daily Cash Coverage model (Modeler) Global",
            path: "treasuryModelerAnalyticsGlobal/liquidityRiskGlobal/tmccDailyCashCoverageModelGlobal",
            pageId: ["WA_TMOD_TMCC_DAILY_CASH_COVERAGE_MODEL_GLOBAL"],
            component: () => (
              <Other page="TMCC Daily Cash Coverage model of Treasury Modeler Analytics Global" />
            ),
          }, */
          {
            title: "DAF2 Template (Modeler) Global",
            path: "treasuryModelerAnalyticsGlobal/liquidityRiskGlobal/daf2TemplateGlobal",
            pageId: ["WA_TMOD_DAF2_TEMPLATE_GLOBAL"],
            component: () => <DAF2TreasuryModelerGlobal />,
          },
          {
            title: "Balance Sheet Liquidity Ratio (Modeler) Global",
            path: "treasuryModelerAnalyticsGlobal/liquidityRiskGlobal/balanceSheetLiquidityRatioGlobal",
            pageId: ["WA_TMOD_BALANCE_SHEET_LIQUIDITY_RATIO_GLOBAL"],
            component: () => <BalSheetLiqRatioModelerGlobal />,
          },
          {
            title: "Short Term Debt (Modeler) Global",
            path: "treasuryModelerAnalyticsGlobal/liquidityRiskGlobal/shortTermDebtGlobal",
            pageId: ["WA_TMOD_SHORT_TERM_DEBT_GLOBAL"],
            component: () => <STDTDModelerGlobal />,
          },
          {
            title: "Long Term Debt Concentration (Modeler) Global",
            path: "treasuryModelerAnalyticsGlobal/liquidityRiskGlobal/longTermDebtConcentrationGlobal",
            pageId: ["WA_TMOD_LONG_TERM_DEBT_CONCENTRATION_GLOBAL"],
            component: () => <LTDCModelerGlobal />,
          },
        ],
      },
      {
        title: "Liquidity Plan (Modeler) Global",
        path: "treasuryModelerAnalyticsGlobal/liquidityPlanGlobal",
        pageId: ["WA_TMOD_LIQUIDITY_PLAN_GLOBAL"],
        component: () => (
          <LiquidityPlanGlobal page="Liquidity Plan of Treasury Modeler Analytics Global View" />
        ),
      },
      {
        title: "Control - GL Reconciliation (Modeler) Global",
        path: "treasuryModelerAnalyticsGlobal/controlGLReconciliationGlobal",
        pageId: ["WA_TMOD_CONTROL_GL_RECONCILIATION_GLOBAL"],
        component: () => <ControlGLReconciliationModelerGlobal />,
      },
      {
        title: "Additional Schedules (Modeler) Global",
        path: "treasuryModelerAnalyticsGlobal/additionalSchedulesGlobal",
        pageId: ["WA_TMOD_ADDITIONAL_SCHEDULES_GLOBAL"],
        subPages: [
          {
            title: "Sensitivity GAP (Modeler) Global",
            path: "treasuryModelerAnalyticsGlobal/additionalSchedulesGlobal/sensitivityGapGlobal",
            pageId: ["WA_TMOD_SENSITIVITY_GAP_GLOBAL"],
            component: () => <SensitivityGAPGlobal />,
          },
          {
            title: "Liquidity GAP (Modeler) Global",
            path: "treasuryModelerAnalyticsGlobal/additionalSchedulesGlobal/liquidityGapGlobal",
            pageId: ["WA_TMOD_LIQUIDITY_GAP_GLOBAL"],
            component: () => <LiquidityGAPGlobal />,
          },
          {
            title: "Balance Sheet Run Off (Modeler) Global",
            path: "treasuryModelerAnalyticsGlobal/additionalSchedulesGlobal/balanceSheetRunOffGlobal",
            pageId: ["WA_TMOD_BALANCE_SHEET_RUN_OFF_GLOBAL"],
            component: () => <Other page="Balance Sheet Run Off Page Global" />,
          },
        ],
      },
    ],
  },
  {
    title: "TFSC Forecast/Planning",
    path: "tfscForecastPlanning",
    pageId: ["WA_TFSC_FORECAST_OR_PLANNING_PARENT"],
    subPages: [
      {
        title: "Treasury MTBP Template",
        path: "tfscForecastPlanning/treasuryMTBPTemplate",
        pageId: ["WA_FCP_TREASURY_MTBP_TEMPLATE"],
        component: () => <TreasuryMTBPTemplate page="Treasury MTBP Template" />,
      },
    ],
  },
  {
    title: "Finance",
    path: "finance",
    pageId: ["WA_FINANCE_PARENT"],
    subPages: [
      {
        title: "Finance Reporting Table",
        path: "finance/financeReport",
        pageId: ["WA_FIN_REPORTING_TABLE"],
        component: () => <FinanceReport page="Finance Report" />,
      },
    ],
  },
  {
    title: "Application Management",
    path: "applicationManagement",
    pageId: ["WA_FILE_UPLOAD"],
    component: () => (
      <FileUploadProvider>
        <FileUpload />
      </FileUploadProvider>
    ),
  },
  {
    title: "Empyrean OP DB Management",
    path: "empyreanDBManagement",
    pageId: ["WA_EMPYREAN_DB_MANAGEMENT"],
    component: () => (
      <EmpyreanProvider>
        <EmpyreanOPDB />
      </EmpyreanProvider>
    ),
  },
  {
    title: "Document Center",
    path: "documentCenter",
    pageId: ["WA_DOCUMENT_UPLOAD"],
    component: () => (
      <DocumentUploadProvider>
        <DocumentUpload />
      </DocumentUploadProvider>
    ),
  },
  {
    title: "Data Upload",
    path: "dataUpload",
    pageId: ["WA_DATA_UPLOAD"],
    component: () => (
      <DataUploadProvider>
        <DataUpload />
      </DataUploadProvider>
    ),
  },
  {
    title: "Admin Management",
    path: "adminManagement",
    pageId: [WA_ADMIN_MANAGEMENT],
    component: () => (
      <AdminManagementProvider>
        <AdminManagement />
      </AdminManagementProvider>
    ),
  },
  {
    title: "Profile",
    path: "profile",
    pageId: ["WA_PROFILE"],
    component: () => <Profile />,
  },
];
